import Vue from 'vue'
import VueRouter from 'vue-router'
/*ElementUI*/
import ele from 'element-ui'

/*********************    前台页面   ************************/
import Home from '../views/show/index.vue'
// 首页主体内容
import HomeContent from '../views/show/home/homeContent.vue'
// 登录首页
import LoginHome from '../views/show/home/loginHome.vue'
// 文章详情页
import ArticleDetail from '../views/show/home/articleDetail.vue'
// 产品
import Product from '../views/show/product/product.vue'
import ProductNew from '../views/show/product/productNew.vue'
// 产品-目录
import ProductDirectory from '../views/show/product/productDirectory.vue'
// 产品-安装包
import ProductPackage from '../views/show/product/productPackage.vue'
// 产品-安装包详情页
import ProductPackageDetail from '../views/show/product/productPackageDetail.vue'
// 产品-文档
import ProductDocument from '../views/show/product/productDocument.vue'
// 产品-培训
import ProductTrain from '../views/show/product/productTrain.vue'
// 产品-常见问题
import ProductQuestion from '../views/show/product/productQuestion.vue'
// 文档下载
import Document from '../views/show/document/document.vue'
// 在线培训
import OnlineTrain from '../views/show/onlineTrain/onlineTrain.vue'
// 在线培训-详情页
import OnlineTrainDetail from '../views/show/onlineTrain/onlineTrainDetail.vue'
// 常见问题
import Question from '../views/show/question/question.vue'
// 常见问题-详情页
import QuestionDetail from '../views/show/question/questionDetail.vue'
// 问题反馈
import Feedback from '../views/show/feedback/feedback.vue'
// 最新活动
import Activity from '../views/show/activity/activity.vue'
// 最新活动-详情页
import ActivityDetail from '../views/show/activity/activityDetail.vue'
// 登录
import Login from '../views/show/login/login.vue'
// 注册
import Register from '../views/show/login/register.vue'
// 申请试用账号
import ApplyForTest from '../views/show/login/applyForTest.vue'
// 找回密码
import FindPassword from '../views/show/login/findPassword.vue'
/*********************    End   ************************/

/*********************    后台管理页面   ************************/
import Admin from '../views/admin/index.vue'
// 个人中心主页
import AdminHome from '../views/admin/personHome.vue'
// 个人信息
import PersonInformation from '../views/admin/personInformation.vue'
// 修改密码
import ChangePassword from '../views/admin/changePassword.vue'
// 我的产品
import MyProduct from '../views/admin/myProduct.vue'
// 下载记录
import DownloadHistory from '../views/admin/downloadHistory.vue'
// 报名记录
import EnterHistory from '../views/admin/enterHistory.vue'
// 报名记录详情
import EnterDetail from '../views/admin/enterDetail.vue'
// 问题反馈
import ProblemFeedback from '../views/admin/problemFeedback.vue'
// 问题反馈-详情页
import ProblemDetail from '../views/admin/problemDetail.vue'
// IP产品
import IpProduct from '../views/admin/ipProduct.vue'
// IP产品-项目列表
import IpProjectList from '../views/admin/ipProjectList.vue'
// IP产品-详情页
import IpProjectDetail from '../views/admin/ipProductDetail.vue'
// 消息列表
import MessageList from '../views/admin/messageList.vue'
// 消息列表-详情页
import MessageDetail from '../views/admin/messageDetail.vue'
// 搜索结果
import search from '../views/show/search/search.vue'
import axios from 'axios'
/*********************    End   ************************/

// 防止重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => {})
};
Vue.use(VueRouter)

const routes = [
	/**
	 * @type: show 代表前台页面
	 */
  {
    path: '/',
    name: 'home',
    component: Home,
	redirect: '/index',
	children: [
		{ path: '/index', name: '首页主体内容', component: HomeContent, meta: { title: '首页主体内容', type: 'show' } },
		{ path: '/loginHome', name: '个人首页', component: LoginHome, meta: { title: '个人首页', type: 'show' } },
		{ path: '/articleDetail', name: '文章详情页', component: ArticleDetail, meta: { title: '文章详情页', type: 'show' } },
		{ path: '/product', name: '产品-目录', component: ProductDirectory, meta: { title: '产品', type: 'show' } },
		{ path: '/productDirectory', name: '产品', component: Product, meta: { title: '产品-目录', type: 'show' } },
		{ path: '/productList', name: '产品', component: ProductNew, meta: { title: '产品-目录', type: 'show' } },
		{ path: '/productPackage', name: '产品-安装包', component: ProductPackage, meta: { title: '产品-安装包', type: 'show' } },
		{ path: '/productPackageDetail', name: '产品-安装包详情', component: ProductPackageDetail, meta: { title: '产品-安装包详情', type: 'show' } },
		{ path: '/productDocument', name: '产品-文档', component: ProductDocument, meta: { title: '产品-文档', type: 'show' } },
		{ path: '/ipProduct', name: 'IP产品', component: IpProduct, meta: { title: 'IP产品', type: 'show' } },
		{ path: '/ipProjectList', name: 'IP产品-项目列表', component: IpProjectList, meta: { title: 'IP产品-项目列表', type: 'show' } },
		{ path: '/ipProductDetail', name: 'IP产品-详情页', component: IpProjectDetail, meta: { title: 'IP产品-详情页', type: 'admin' } },
		{ path: '/productTrain', name: '产品-培训', component: ProductTrain, meta: { title: '产品-培训', type: 'show' } },
		{ path: '/productQuestion', name: '产品-常见问题', component: ProductQuestion, meta: { title: '产品-常见问题', type: 'show' } },
		{ path: '/document', name: '文档下载', component: Document, meta: { title: '文档下载', type: 'show' } },
		{ path: '/onlineTrain', name: '在线培训', component: OnlineTrain, meta: { title: '在线培训', type: 'show' } },
		{ path: '/onlineTrainDetail', name: '在线培训-详情页', component: OnlineTrainDetail, meta: { title: '在线培训-详情页', type: 'show' } },
		{ path: '/question', name: '常见问题', component: Question, meta: { title: '常见问题', type: 'show' } },
		{ path: '/questionDetail', name: '常见问题-详情页', component: QuestionDetail, meta: { title: '常见问题-详情页', type: 'show' } },
		{ path: '/feedback', name: '问题反馈', component: Feedback, meta: { title: '问题反馈', type: 'admin' } },
		{ path: '/activity', name: '最新活动', component: Activity, meta: { title: '最新活动', type: 'show' } },
		{ path: '/activityDetail', name: '最新活动-详情页', component: ActivityDetail, meta: { title: '最新活动-详情页', type: 'show' } },
		{ path: '/login', name: '登录', component: Login, meta: { title: '登录', type: 'show' } },
		{ path: '/register', name: '注册', component: Register, meta: { title: '注册', type: 'show' } },
		{ path: '/applyForTest', name: '申请试用账号', component: ApplyForTest, meta: { title: '申请试用账号', type: 'show' } },
		{ path: '/findPassword', name: '找回密码', component: FindPassword, meta: { title: '找回密码', type: 'show' } },
		{ path: '/search', name: '搜索结果', component: search, meta: { title: '搜索结果', type: 'show' } }
	]
  },
  /**
   * @type: admin 代表后台页面
   */
  {
    path: '/admin',
    name: '主页',
    component: Admin,
  	redirect: '/adminIndex',
  	children: [
  		{ path: '/adminIndex', name: '个人中心主页', component: AdminHome, meta: { title: '个人中心主页', type: 'admin' } },
		{ path: '/personInformation', name: '个人信息', component: PersonInformation, meta: { title: '个人信息', type: 'admin' } },
		{ path: '/changePassword', name: '修改密码', component: ChangePassword, meta: { title: '修改密码', type: 'admin' } },
		{ path: '/myProduct', name: '我的产品', component: MyProduct, meta: { title: '我的产品', type: 'admin' } },
		{ path: '/downloadHistory', name: '下载记录', component: DownloadHistory, meta: { title: '下载记录', type: 'admin' } },
		{ path: '/enterHistory', name: '报名记录', component: EnterHistory, meta: { title: '报名记录', type: 'admin' } },
		{ path: '/enterDetail', name: '报名记录详情', component: EnterDetail, meta: { title: '报名记录详情', type: 'admin' } },
		{ path: '/problemFeedback', name: '我的-问题反馈', component: ProblemFeedback, meta: { title: '我的-问题反馈', type: 'admin' } },
		{ path: '/problemDetail', name: '问题反馈-详情页', component: ProblemDetail, meta: { title: '问题反馈-详情页', type: 'admin' } },
		
		{ path: '/messageList', name: '消息列表', component: MessageList, meta: { title: '消息列表', type: 'admin' } },
		{ path: '/messageDetail', name: '消息列表-详情页', component: MessageDetail, meta: { title: '消息列表-详情页', type: 'admin' } }
  	]
  },
 
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
	  // 如果跳转到详情页需要滚动条初始化
	  if(
	  to.path == '/questionDetail' || 
	  to.path == '/onlineTrainDetail' || 
	  to.path == '/activityDetail' || 
	  to.path == '/problemDetail' || 
	  to.path == '/ipProductDetail' || 
	  to.path == '/articleDetail' || 
	  to.path == '/messageDetail' || 
	  to.path == '/productDirectory'
	  ) {
		  return { x: 0, y: 0 }; // 返回{x: 0, y: 0}表示滚动到页面左上角
	  }
    }
})


// 路由守卫
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	document.title = (to.meta.title?(to.meta.title+'-'):'')+'UVOS-客户在线支持系统';
	// 判断Token是否存在
	let token = localStorage.getItem('Authorization');
	let isUpdatePassword = localStorage.getItem('isUpdatePassword')=='true';
	console.log(to);
	if(to.path!='/login'&&to.path!='/register'){
		localStorage.setItem('backurl',to.fullPath);
	};
	if (token) {
	    if(isUpdatePassword && to.path != '/changePassword'){
			next()
			//next('/changePassword')
		}else{
			next()
		}
	} else {
		// 前台页面无需登录
		if(
			to.path == '/index' || 
			to.path == '/login' || 
			to.path == '/register' || 
			to.path == '/articleDetail' || 
			to.path == '/findPassword'
		){
			next();
		}else{
			ele.Message({
				message: '请先登录',
				type: 'warning'
			});
			next('/login')
		}
	}
})
router.afterEach((to, from)=>{
	const $justpost=Vue.prototype.$justpost;
	$justpost.post('member/log/visit/add',
		{
			title:to.name,
			path:to.fullPath
		}
	).then((res)=>{})
	.catch(err => {})
})
export default router
